import React, { useState } from "react";
import Ideadox from "../../logos/Ideadox.svg";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Star from "../../logos/Star.svg";
import { caseStudies2 } from "../CaseStudy";
import CaseStudyCard from "../CaseStudyCard";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { isMobile } from "react-device-detect";

const CaseStudy7 = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const displayedCaseStudies = caseStudies2.slice(0, 3);

  return (
    <div
      style={{
        backgroundColor: "#F0DFD8",
        padding: "2rem",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        overflowX: "hidden",
        overflow: "hidden",
      }}
    >
      <header
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          padding: "1rem",
          boxSizing: "border-box",
          top: 5,
          position: "absolute",
        }}
      >
        <div
          onClick={() => navigate("/caseStudy")}
          style={{ cursor: "pointer" }}
        >
          <img src={Ideadox} alt="Ideadox" />
        </div>
        {isMobile ? (
          <div>
            <Button
              className="border border-black mt-2 rounded-full"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent white
                  boxShadow: "none",
                },
              }}
            >
              <MenuItem
                onClick={handleMenuClose}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Blog
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/caseStudy")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                Case Study
              </MenuItem>
              <MenuItem
                onClick={() => navigate("/aboutus")}
                style={{
                  color: "#000",
                  fontFamily: "Golos Text",
                }}
              >
                About
              </MenuItem>
            </Menu>
            <button className="border border-black py-1 px-2 mt-2 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </div>
        ) : (
          <nav className="space-x-4 mr-4">
            <button
              className="hover:underline"
              onClick={() => {
                /* handle click */
              }}
            >
              Blog
            </button>
            <button
              className="hover:underline"
              onClick={() => {
                navigate("/caseStudy");
              }}
            >
              Case Study
            </button>
            <button
              className="hover:underline"
              onClick={() => navigate("/aboutus")}
            >
              About
            </button>
            <button className="border border-black py-1 px-3 rounded-full hover:bg-black hover:text-white">
              Get In Touch
            </button>
          </nav>
        )}
      </header>
      <Typography
        style={{
          fontFamily: "Bricolage Grotesque",
          fontWeight: 600,
          fontSize: isMobile ? "24px" : "48px", // Adjust font size for mobile
          color: "#2F2F30",
          lineHeight: isMobile ? "30px" : "65px", // Adjust line height for mobile
          textAlign: "left",
          marginTop: isMobile ? "80px" : "70px", // Adjust margin for mobile
          maxWidth: isMobile ? "100%" : "50%", // Adjust width for mobile
          overflowWrap: "break-word",
        }}
      >
        Crafting a User-Centric Product Roadmap for Non-Technical Founders
      </Typography>
      <div
        className={`flex flex-col items-start px-8 ${
          isMobile ? "mt-6" : "mt-2"
        }`}
        style={{
          marginRight: isMobile ? "50%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "35px",
          }}
        >
          Background
        </Typography>
      </div>
      <div>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 350,
            fontSize: isMobile ? "20px" : "20px",
            color: "#78787A",
            width: isMobile ? "110%" : "741px",
            marginTop: "10px",
            marginLeft: isMobile ? "-2%" : "",
            textAlign: "left",
          }}
        >
          Client A, a non-technical founder, lacked a clear product roadmap and
          had only provided Figma designs without specifying the technical
          aspects or requirements for scalability. This approach resulted in an
          incomplete product with essential features missing, making it
          challenging to retain users.
        </Typography>
      </div>
      {!isMobile && (
        <div className="fixed top-28 left-20 h-1/2 w-64 p-2">
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: "22px",
              fontWeight: 600,
              color: "#2F2F30",
              textAlign: "left",
            }}
          >
            CONTENTS
          </Typography>
          <ul>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Background
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                CPO Approach & Solution
              </Typography>
            </li>
            <li>
              <Typography
                align="left"
                style={{
                  marginTop: "8px",
                  fontFamily: "Golos Text",
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#78787A",
                }}
              >
                Impact
              </Typography>
            </li>
          </ul>
        </div>
      )}
      <div
        className="flex flex-col items-start mt-2"
        style={{
          marginRight: isMobile ? "45%" : "9%",
          width: isMobile ? "60%" : "40%",
        }}
      >
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "160%" : "",
          }}
        >
          CPO Approach & Solution
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "170%" : "850px",
          }}
        >
          As the acting CPO for Client A, IDEADOX led the team in a
          comprehensive transformation to boost technical efficiency.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Developing a Phased Product Roadmap with Core Feature Prioritization
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          We worked closely with Client C to define a strategic product roadmap,
          focusing first on implementing core features that aligned with the
          business goals and met initial user needs. This phased approach
          allowed us to build a robust foundation and scale the product
          incrementally without overwhelming the development team. .
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Identifying and Addressing Essential User Features
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          IDEADOX prioritized essential features, such as haptics,
          notifications, and performance optimization, to deliver a smoother,
          more engaging experience for users. This prioritization ensured that
          users had access to key functionalities that enhanced their overall
          interaction with the app.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "22px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
            width: isMobile ? "170%" : "90%",
          }}
        >
          Creating a User-Centered Product Development Process
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          We established a feedback loop with users, allowing us to gather
          insights about user preferences and adjust the roadmap based on real
          user behavior and needs. This iterative feedback approach helped
          refine the product direction to ensure it consistently met user
          expectations.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: "28px",
            color: "#2F2F30",
            textAlign: "left",
            marginTop: "40px",
          }}
        >
          Impact
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            Improved product engagement and usability
          </span>{" "}
          by focusing on core, high-impact features.
        </Typography>
        <Typography
          style={{
            fontFamily: "Golos Text",
            fontWeight: 400,
            fontSize: isMobile ? "20px" : "20px",
            textAlign: "left",
            marginTop: "10px",
            color: "#78787A",
            width: isMobile ? "185%" : "850px",
          }}
        >
          •{" "}
          <span
            style={{
              color: "#2F2F30",
            }}
          >
            Reduced development times and costs,
          </span>{" "}
          as a phased approach minimized scope creep and allowed the team to
          focus on essentials.
        </Typography>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Center horizontally
            marginTop: "60px",
            width: isMobile ? "160%" : "140%", // Ensure it takes full width
          }}
        >
          <img src={Star} alt="Star" style={{ marginRight: "0.5rem" }} />
          <Typography
            style={{
              fontSize: 28,
              fontFamily: "Bricolage Grotesque",
              fontWeight: 200,
              color: "#2F2F30",
            }}
          >
            Case Study
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Center horizontally
            width: "140%", // Ensure it takes full width
          }}
        >
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontSize: isMobile ? "26px" : "34px",
              fontWeight: 600,
              textAlign: "center",
              marginTop: "40px",
              marginLeft: isMobile ? "17%" : "",
            }}
          >
            Read More
          </Typography>
        </div>
        <div
          className="case-studies-list"
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            marginTop: "20px",
            flexDirection: isMobile ? "column" : "row", // Change direction for mobile
            alignItems: isMobile ? "center" : "flex-start", // Center items on mobile
            marginLeft: isMobile ? "12%" : "",
          }}
        >
          {displayedCaseStudies.map((study, index) => (
            <div
              key={index}
              style={{
                width: "300px", // Set a consistent width
                padding: "16px",
              }}
            >
              <CaseStudyCard
                title={study.title}
                link={study.link}
                image={study.image}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaseStudy7;
